import CodeStore from 'stores/CodeStore';
import EtsngCode from 'models/EtsngCode';

const NAMESPACE = 'etsng';

export default class EtsngCodeStore extends CodeStore {

  codes = this.collection({
    model: EtsngCode
  })

  async fetchCodeData(code) {
    await super.fetchCodeData(code, NAMESPACE);
  }

}



// WEBPACK FOOTER //
// ./src/stores/EtsngCodeStore.js